import PropTypes from 'prop-types';
import { Fragment } from 'react';

import Modal from 'react-modal';

const StyledModal = ({ children, closeModal, modalIsOpen }) => {
	return (
		<Fragment>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				className={'styled-modal'}
				closeTimeoutMS={500}
			>
				{children}
			</Modal>
		</Fragment>
	);
};

StyledModal.propTypes = {
	children: PropTypes.node,
	closeModal: PropTypes.func,
	active: PropTypes.bool,
	modalIsOpen: PropTypes.bool,
};

export default StyledModal;
